// extracted by mini-css-extract-plugin
export default {"details":"CeccEf","actions":"HmQ8Z7","actionButton":"VvWw29","mobile":"maD_R8","leftActions":"xQEjrK","location":"oamvV0"};